import { ContractDateConflict } from './contract-date-conflict';

export class ContractDateConflictsModalData {

  constructor(public title: string, public message: string, public conflicts: ContractDateConflict[]) {}
}
